import './Home.css';
import '../GlobalPages.css';
import NavMenuOption from '../../components/header/navMenu/navMenuItem/NavMenuOption';
import { useState } from 'react';
import { CurrentUser } from '../../components/login/CurrentUser';
import Loader from '../../components/loader/Loader';
import { useHeaderOptions } from '../../components/hooks/useHeaderOptions';


export default function Home() {

    let [user, setUser] = useState("Aguardando login...");
    let options = useHeaderOptions();
    CurrentUser.OnLogin.Add((user) => {
        if (user)
            setUser(`${user.Licence.Name}`);        
    });



    return (
        <>
            <Loader />
            <div className="PageComponent HomeComponent">   
                <div className='GridComponent'>
                    {
                        options.Select(s => (
                            <NavMenuOption
                                Image={s.Image}
                                Title={s.Title}
                                SubTitle={s.SubTitle}
                                URL={s.URL}
                                key={s.URL}
                                Help={s.Help} />
                        ))
                    }
                </div>
            </div>
        </>
    )
}